<template>
  <div class="disease-detail-container">
    <van-nav-bar
      :border="false"
      title="病虫害防治"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="header">
      <div class="base-info">
        <div class="info">
          <div class="name">
            {{ cropData.name }}
          </div>
          <div class="desc">
            [ 病虫害防治百科 ]
          </div>
        </div>
        <van-image
          :src="cropData.pic"
          width="90"
          height="90"
          fit="cover"
          round
        />
      </div>
    </div>
    <div class="tabs-container">
      <van-tabs v-model="activeName" color="#20CAA0" sticky>
        <van-tab title="全部" name="全部" />
        <van-tab title="病害" name="病害" />
        <van-tab title="虫害" name="虫害" />
      </van-tabs>
      <div class="type-grid">
        <router-link
          v-for="i in cropPestsData.sick"
          v-show="activeName!=='虫害'"
          :key="i.id"
          :to="{name:'DiseasePestDetail',params:{id:i.id}}"
          class="item"
        >
          <van-image :src="i.pic" width="100%" height="128" fit="cover" lazy-load />
          <div class="name">
            {{ i.name }}
          </div>
        </router-link>
        <router-link
          v-for="i in cropPestsData.pest"
          v-show="activeName!=='病害'"
          :key="i.id"
          :to="{name:'DiseasePestDetail',params:{id:i.id}}"
          class="item"
        >
          <van-image :src="i.pic" width="100%" height="128" lazy-load />
          <div class="name">
            {{ i.name }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'DiseasePestCrop',
  data() {
    return {
      id: this.$route.query.id,
      name: this.$route.query.name,
      cropData: {},
      cropPestsData: {
        pest: [],
        sick: []
      },
      activeName: '全部'
    }
  },
  created() {
    if (this.id) {
      this.findById(this.id)
    } else if (this.name) {
      this.findByName(this.name)
    }
  },
  methods: {
    findByName(name) {
      api.controlAgriDiseasesFindByName({
        agri_name: name
      }).then(res => {
        this.cropPestsData = res.data
        this.cropData = res.type_info
      })
    },
    findById(id) {
      api.controlAgriDiseasesFindById({
        type_id: id
      }).then(res => {
        this.cropPestsData = res.data
        this.cropData = res.type_info
      })
    }
  }
}
</script>

<style lang="less" scoped>
.disease-detail-container {
  position: relative;
  .van-nav-bar {
    position: sticky;
    top: 0;
  }
}
.header {
  height: 300px;
  padding: 0 30px 100px;
  background: url("~@/assets/images/more/diseasePest/crop-header-bg.png") center /cover no-repeat;
  .base-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 200px;
    margin: 0 auto;
    color: #fff;
    .name {
      font-size: 22px;
      font-weight: 600;
    }
    .desc {
      margin-top: 20px;
      font-size: 12px;
    }
  }
}
.tabs-container {
  position: absolute;
  top: 250px;
  left: 10px;
  right: 10px;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  padding: 10px;
}
.type-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  margin-top: 10px;
  .item {
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(135, 135, 135, 0.3);
    overflow: hidden;
    .name {
      padding: 10px;
      text-align: center;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
